import ChordSheetJS from "chordsheetjs";
import hbs from "handlebars-inline-precompile";

import "../node_modules/chordsheetjs/lib/handlebars_helpers";

const template = hbs`
{{~#with song~}}
  {{~#if title~}}
    <h1>{{~title~}}</h1>
  {{~/if~}}
  {{~#if subtitle~}}
    <h2>{{~subtitle~}}</h2>
  {{~/if~}}
  <div class="chord-sheet">
    {{~#each paragraphs as |paragraph|~}}
      <div class="{{paragraphClasses paragraph}}">
        {{~#each lines as |line|~}}
          {{~#if (shouldRenderLine line)~}}
            <div class="{{lineClasses line}}">
              {{~#each words as |word|~}}
                <div class="word">
                  {{~#each items as |item|~}}
                    {{~#if (isChordLyricsPair item)~}}
                        <div class="column"><!--
                          --><div class="chord">{{chords}}</div><!--
                          --><div class="lyrics">{{lyrics}}</div><!--
                        --></div>
                    {{~/if~}}
                  {{~/each~}}
                </div>
                {{~#if (isTag item)~}}
                  {{~#if (isComment item)~}}
                    <div class="comment">{{value}}</div>
                  {{~/if~}}
                {{~/if~}}
              {{~/each~}}
            </div>
          {{~/if~}}
        {{~/each~}}
      </div>
    {{~/each~}}
  </div>
{{~/with~}}`;

/**
 * Formats a song into HTML. It uses DIVs to align lyrics with chords, which makes it useful for responsive web pages.
 */
class HtmlDivFormatter {
  /**
   * Formats a song into HTML.
   * @param {Song} song The song to be formatted
   * @returns {string} The HTML string
   */
  format(song) {
    song.paragraphs.forEach(paragraph => {
      paragraph.lines.forEach(line => {
        const words = [{ items: [] }];
        line.items.forEach(item => {
          const chord = [item.chords];
          const tokens = item.lyrics.split(" ");
          const trueTokens = tokens.map(e => e + " ");
          if (trueTokens.length && trueTokens[trueTokens.length - 1] === " ") {
            delete trueTokens[trueTokens.length - 1];
          } else {
            const value = trueTokens[trueTokens.length - 1];
            trueTokens[trueTokens.length - 1] = value.slice(
              0,
              value.length - 1
            );
          }

          trueTokens.forEach(lyrics => {
            words[words.length - 1].items.push(
              new ChordSheetJS.ChordLyricsPair(chord.pop(), lyrics)
            );
            if (lyrics[lyrics.length - 1] === " ") {
              words.push({ items: [] });
            }
          });
        });
        line.words = words;
      });
    });

    return template({ song });
  }
}

export default HtmlDivFormatter;



// WEBPACK FOOTER //
// ./src/song_formatter.js